import WRAP from 'WRAP-JS';

class Tooltip {
  contentsList = [];
  tooltip;
  downX;
  downY;
  cancel = false;
  CLICK_RANGE = 2;
  OFFSET_X = 20;
  OFFSET_Y = 14;

  constructor(elem, tooltipElemId) {
    this.elem = elem;
    this.tooltip = document.getElementById(tooltipElemId);
    this.initialize();
  }

  initialize() {
    this.elem.addEventListener('mouseup', () => {
      this.downX = this.downY = undefined;
    });

    this.elem.addEventListener('mousedown', event => {
      this.downX = event.clientX;
      this.downY = event.clientY;
      this.hideTooltip();
    });

    this.elem.addEventListener('mousemove', event => {
      if (this.downX && this.downY) {
        if(Math.abs(this.downX - event.clientX) > this.CLICK_RANGE || Math.abs(this.downY - event.clientY) > this.CLICK_RANGE) {
          this.hideTooltip();
        }
      }
    });

    this.tooltip.addEventListener('mousedown', () => {
      this.hideTooltip();
      return false;
    });

    WRAP.Geo.addEventHandler('touch', (layer, reference, screenPoint) => {
      if(!layer || !reference) {
        return;
      }

      if(!this.cancel && !this.touchHandler(layer, reference, screenPoint)) {
        this.cancel = true;
        setTimeout(()=> {
          this.cancel = false;
        }, 1);
      }
    });

    WRAP.Geo.addEventHandler('boundsChange', () => {
      this.hideTooltip();
    });
  }

  addLayer(contents) {
    this.contentsList.push(contents);
  }

  removeContents(contents) {
    const idx = this.contentsList.findIndex(c => {
      return c.getLayer().name() === contents.getLayer().name();
    });
    this.contentsList.splice(idx, 1);
  }

  touchHandler(layer, reference, screenPoint) {
    if(layer && reference) {
      const targetLayerName = layer.name();
      const targetContents = this.contentsList.find(c => {
        if (c.getLayer().name() === targetLayerName) {
          return (typeof c.tooltip === 'function');
        }
        return false
      });
      if (targetContents) {
        const tooltipData = targetContents.tooltip(layer, reference, screenPoint);
        this.tooltip.innerHTML = tooltipData;
        this.fixPosition(screenPoint);
        this.showTooltip();
        if (typeof targetContents.hideTooltip === 'function') {
          const hideHandler = () => {
            targetContents.hideTooltip();
            this.tooltip.removeEventListener('hideTooltip', hideHandler);
          }
          this.tooltip.addEventListener('hideTooltip', hideHandler);
        }
        return false;
      }
      return true;
    }
  };

  fixPosition(screenPoint) {
    let lr;
    let right;
    let left;
    const pw = this.tooltip.parentNode.clientWidth;
    if(pw / 2 < screenPoint.x) {
      lr = "r";
      right = pw - screenPoint.x + this.OFFSET_X + "px";
      left = "auto";
    } else {
      lr="l";
      left = screenPoint.x + this.OFFSET_X + "px";
      right = "auto";
    }

    let tb;
    let top;
    let bottom;
    const ph = this.tooltip.parentNode.clientHeight;
    if(ph / 2 > screenPoint.y) {
      tb = "t";
      top = screenPoint.y - this.OFFSET_Y + "px";
      bottom = "auto";
    } else {
      tb = "b";
      top = "auto";
      bottom = ph - screenPoint.y - this.OFFSET_Y + "px";
    }
    this.tooltip.classList.remove('l', 'r', 'c', 't', 'm', 'b');
    this.tooltip.classList.add(lr, tb);

    Object.assign(this.tooltip.style, {
      left,
      right,
      top,
      bottom
    });
  }

  hideTooltip() {
    this.tooltip.style.display = 'none';
    this.tooltip.dispatchEvent(new Event('hideTooltip'));
  }

  showTooltip() {
    this.tooltip.style.display = 'block';
  }
  toggleTooltip() {
    this.tooltip.style.display = this.tooltip.style.display === 'none' ? 'block' : 'none';
  }
}

export default Tooltip;